var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hh-btn',{staticClass:"add-remove-button",attrs:{"text":_vm.displayText,"disabled":_vm.disabled,"type":_vm.buttonType},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }